import Link from "next/link";
import { Layout } from "../../components/layout/layout.comp";
import { LongCopy } from "../../components/longCopy/longCopy.comp";

export default function PrivacyPage() {
    return (
        <Layout
            showHeader={true}
            showFooter={true}
            title="Privacy Policy" 
            url={`https://www.bracketsninja.com/privacy`}
            >

            <LongCopy title="Privacy Policy" >
                <p>
                    <span style={{ fontWeight: 400 }}>Last Updated: August 2022</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        This Privacy Policy describes how Common Ninja Ltd., with its
                        affiliated companies (&ldquo;
                    </span>
                    <strong>Common Ninja</strong>
                    <span style={{ fontWeight: 400 }}>&ldquo;, &ldquo;</span>
                    <strong>we</strong>
                    <span style={{ fontWeight: 400 }}>&ldquo;, &ldquo;</span>
                    <strong>our</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo; or &ldquo;</span>
                    <strong>us</strong>
                    <span style={{ fontWeight: 400 }}>
                        &ldquo;) collects, uses, and discloses personal data of individuals
                        in connection to their use of our website (
                    </span>
                    <a href="http://www.commoninja.com">
                        <span style={{ fontWeight: 400 }}>www.commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        ), our Common Ninja Developer Platform, including its features,
                        integrations and applications (the &ldquo;
                    </span>
                    <strong>Platform</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;), or otherwise their interaction with us or our content,
                        communications, and online ads (collectively, our &ldquo;
                    </span>
                    <strong>Services</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;).</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We process three main categories of personal data:&nbsp;
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>User Data</strong>
                        <span style={{ fontWeight: 400 }}>: personal data</span>
                        <strong>&nbsp;</strong>
                        <span style={{ fontWeight: 400 }}>
                            relating to developers who use the Platform to create an
                            e-commerce app or others who use our Platform&rsquo;s features or
                            applications (such as website&rsquo;s owners or merchants)
                            (collectively, &ldquo;
                        </span>
                        <strong>Users</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;), whether if such Users act as individuals or on a
                            Customer&rsquo;s behalf;&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Prospect Data</strong>
                        <span style={{ fontWeight: 400 }}>
                            : personal data&nbsp;relating to visitors of our website,
                            participants at our events, and any other prospective Customer,
                            User, or business partner who visits or otherwise interacts with
                            our Services (collectively, &ldquo;
                        </span>
                        <strong>Prospects</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;);</span>
                    </li>
                    <li>
                        <strong>
                            <strong>Business Data</strong>
                            <span style={{ fontWeight: 400 }}>
                                : If we provide our Services to a business corporate customer (a
                                &ldquo;
                            </span>
                            <strong>Customer</strong>
                            <span style={{ fontWeight: 400 }}>
                                &rdquo;), then we may process personal data
                            </span>{' '}
                            <span style={{ fontWeight: 400 }}>
                                relating to our Customers&rsquo; internal focal persons who
                                directly engage with Common Ninja concerning their
                                organizational use of our Services, their billing contacts and
                                authorized signatories acting on their behalf; as well as the
                                Customers&rsquo; business needs and preferences, as identified
                                to us or recognized through our engagement with them.
                            </span>
                        </strong>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Additionally, Users may use our Common Ninja API to create
                        integrations with third-party e-commerce platforms. When they do so,
                        they may share with us information concerning their shoppers,
                        website visitors, or end-users (&ldquo;
                    </span>
                    <strong>End-Users</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo; and &ldquo;</span>
                    <strong>End-User</strong> <strong>Information</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;, respectively). If such End-User Information contains
                        personal data, we will process it as a data processor, on behalf and
                        under the instruction of the respective User (or Customer, as
                        appropriate) and in accordance with our <Link href="/privacy/dpa">Data Processing
                            Addendum</Link>.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Specifically, this Privacy Policy describes our practices regarding:
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-1">
                            <span style={{ fontWeight: 400 }}>
                                Data Collection &amp; Processing
                            </span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-2">
                            <span style={{ fontWeight: 400 }}>Data Uses</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-3">
                            <span style={{ fontWeight: 400 }}>Data Location</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-4">
                            <span style={{ fontWeight: 400 }}>Data Retention</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-5">
                            <span style={{ fontWeight: 400 }}>Data Disclosure</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-6">
                            <span style={{ fontWeight: 400 }}>
                                Cookies and Data Collection Technologies
                            </span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-7">
                            <span style={{ fontWeight: 400 }}>Communications</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-8">
                            <span style={{ fontWeight: 400 }}>Data Security</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-9">
                            <span style={{ fontWeight: 400 }}>Data Subject Rights</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-10">
                            <span style={{ fontWeight: 400 }}>Data Controller/Processor</span>
                        </a>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <a href="#l-11">
                            <span style={{ fontWeight: 400 }}>Additional Notices</span>
                        </a>
                    </li>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If you are a User, Customer or Prospect, please read this Privacy
                        Policy carefully and make sure that you fully understand it and
                        agree to it.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        You are not legally required to provide us with any personal data.
                        If you do not wish to provide us with your personal data, or to have
                        it processed by us or any of our Service Providers (as defined
                        below), please do not provide it to us and avoid any use of our
                        Services or interaction with us.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        You may also choose not to provide us with &ldquo;optional&rdquo;
                        personal data (when applicable), but please keep in mind that
                        without it, we may not be able to provide you with the full range of
                        our Services or with the best user experience when using our
                        Services.
                    </span>
                </p>
                <h3 id="l-1">1. Data Collection &amp; Processing</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We collect, generate, or receive personal data regarding our Users,
                        Customers and Prospects. Personal data is typically collected and
                        generated through your interaction with our Services, through
                        automatic means, directly from a User, Customer or Prospect, or from
                        other third parties such as our Service Providers (as defined below
                        in Section 5). To the extent that such data concerns a non-human
                        entity (e.g., the bank account of a company or business), we will
                        not regard it as &ldquo;personal data&rdquo; and this Privacy Policy
                        shall not apply to it.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Specifically, we may collect the following types of personal data:
                    </span>
                </p>

                <h4>User Data</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>User Account Information</strong>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            (names, email addresses, passwords and profile pictures, and
                            additional personal data provided to us during the creation of the
                            User&rsquo;s account);
                        </span>
                    </li>
                    <li>
                        <strong>
                            <strong>Direct Interactions and Communications with Us</strong>{' '}
                            <span style={{ fontWeight: 400 }}>
                                (may include recordings and transcripts of your calls and emails
                                with us, e.g., for user enablement or technical support); and
                            </span>
                        </strong>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Platform Usage Information (</strong>
                        <span style={{ fontWeight: 400 }}>
                            connectivity, technical and aggregated usage data, such as user
                            agent, IP addresses, device data (like type, OS, device id,
                            browser version, locale and language settings used), activity
                            logs, session recordings, and the cookies installed or utilized on
                            their device).
                        </span>
                    </li>
                </ol>

                <h4>Prospect Data</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Information Concerning Our Prospects </strong>
                        <span style={{ fontWeight: 400 }}>
                            (contact details and personal data contained in communications
                            with such prospects);
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Website Usage Information </strong>
                        <span style={{ fontWeight: 400 }}>
                            (connectivity, technical and aggregated usage data, such as user
                            agent, IP addresses, device data (like type, OS, device id,
                            browser version, locale and language settings used), activity
                            logs, session recordings, and the cookies and pixels installed or
                            utilized on their device).
                        </span>
                    </li>
                    <li>
                        <strong>
                            <strong>Business Data </strong>
                            <span style={{ fontWeight: 400 }}>
                                (contact details and information regarding our Customers&rsquo;
                                business representatives, e.g., names, business emails, position
                                and personal data contained in communications).
                            </span>
                        </strong>
                    </li>
                </ol>

                <h3 id="l-2">2. Data Uses</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We use personal data as necessary for the performance of our
                        Services (&ldquo;
                    </span>
                    <strong>Performance of Contract</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;); to comply with our legal and contractual obligations
                        (&ldquo;
                    </span>
                    <strong>Legal</strong> <strong>Obligation</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;); and to support our legitimate interests in maintaining and
                        improving our Services, e.g., in understanding how our Services are
                        used, how our campaigns are performing, and gaining insights which
                        help us dedicate our resources and efforts more efficiently; in
                        marketing, advertising, and selling our Services, providing customer
                        service and support operations, and protecting and securing our
                        Users, Customers, Prospects, ourselves and our Services (&ldquo;
                    </span>
                    <strong>Legitimate Interests</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;).&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If you reside or are using the Services in a territory governed by
                        privacy laws under which {`"consent"`} is the only or most appropriate
                        legal basis for the processing of personal data as described herein
                        (in general, or specifically with respect to the types of personal
                        data you expect or elect to process or have processed by us or via
                        the Services, or due to nature of such processing) (&ldquo;
                    </span>
                    <strong>Consent</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;), your acceptance of our{' '}
                    </span>
                    <a href="https://www.bracketsninja.com/terms/">
                        <span style={{ fontWeight: 400 }}>Terms &amp; Conditions</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        and of this Privacy Policy will be deemed as your consent to the
                        processing of your personal data for all purposes detailed in this
                        Policy. If you wish to revoke such consent, please contact us at{' '}
                    </span>
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>.&nbsp;&nbsp;&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Specifically, we use personal data for the following purposes and in
                        reliance on the legal bases for processing noted next to them, as
                        appropriate:
                    </span>
                </p>
                <ul>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To facilitate, operate, enhance and provide our Services{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Performance of Contract; Legitimate Interests);
                            </span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To provide assistance and support, to test and monitor the
                            Services, or diagnose or fix technology problems{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Performance of Contract; Legitimate Interests);
                            </span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To personalize our Services, including by recognizing an
                            individual and remembering their information when they return to
                            our Services, and to provide further localization and
                            personalization capabilities{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Performance of Contract; Legitimate Interests);
                            </span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To facilitate and optimize our marketing campaigns, ad management,
                            and sales operations, and to manage and deliver advertisements for
                            our products and services more effectively, including on other
                            websites and applications. Such activities allow us to highlight
                            the benefits of using our Services and thereby increase your
                            engagement and overall satisfaction with our Services. This
                            includes contextual, behavioral, and interest-based advertising
                            based on your activity, preferences or other data available to us
                            or to our business partners{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Legitimate Interests; Consent);{' '}
                            </span>
                        </em>
                        <span style={{ fontWeight: 400 }}>and</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To facilitate, sponsor and offer certain events, contests, and
                            promotions{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>(Legitimate Interests).</span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To gain a better understanding of how individuals use and interact
                            with our Services, which content and data they have processed
                            through our Services, and how we could improve their user
                            experience and the value they can generate from using the
                            Services, so we could continue improving our products, offerings
                            and the overall performance of our Services{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>(Legitimate Interests);</span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To contact our Users, Customer and Prospect with general or
                            personalized service-related messages, as well as promotional
                            messages that may be of specific interest to them{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Performance of Contract; Legitimate Interests; Consent);
                            </span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To support and enhance our data security measures, including for
                            the purposes of preventing and mitigating the risks of fraud,
                            error, or any illegal, criminal or prohibited activity{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Performance of Contract; Legitimate Interests; Legal
                                Obligation);
                            </span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            To create aggregated statistical data, inferred non-personal data,
                            or anonymized or pseudonymized data (rendered non-personal and
                            non-identifiable), which our business partners or we may use to
                            provide and improve our respective Services, or for any other
                            purpose{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>(Legitimate Interests);</span>
                        </em>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>To enforce our </span>
                        <a href="https://www.bracketsninja.com/terms/">
                            <span style={{ fontWeight: 400 }}>Terms &amp; Conditions</span>
                        </a>
                        <span style={{ fontWeight: 400 }}>
                            , to resolve disputes, to carry out our obligations and enforce
                            our rights, and to protect our business interests and the
                            interests and rights of third parties{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>(Legitimate Interests)</span>
                        </em>
                        <span style={{ fontWeight: 400 }}>;</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            For any other lawful purpose or other purposes that you consent to{' '}
                        </span>
                        <em>
                            <span style={{ fontWeight: 400 }}>
                                (Legal Obligation; Consent).
                            </span>
                        </em>
                    </li>
                </ul>

                <h3 id="l-3">3. Data Location</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We and our authorized Service Providers (defined below) maintain,
                        store and process personal data in the United States of America,
                        Europe, Israel and other locations, as reasonably necessary for the
                        proper performance and delivery of our Services, or as may be
                        required by law.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        While privacy laws may vary between jurisdictions, Common Ninja is
                        committed to protect personal data in accordance with this Privacy
                        Policy and customary industry standards, and such appropriate lawful
                        mechanisms and contractual terms requiring adequate data protection,
                        regardless of any lesser legal requirements that may apply in the
                        jurisdiction to which such data is transferred.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja Ltd. is headquartered in Israel, a jurisdiction which
                        is considered by the European Commission and the UK Secretary of
                        State to be offering an equally adequate level of protection for
                        personal data as is granted in the EEA and the UK, respectively. We
                        transfer personal data from the EEA (including Switzerland) and the
                        UK to Israel on this basis. For data transfers from the EEA or UK to
                        countries which are not considered to be offering an adequate level
                        of data protection, we and the relevant data exporters and importers
                        have entered into Standard Contractual Clauses as approved by the
                        European Commission and UK ICO. You can obtain a copy by contacting
                        us as indicated in Section{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>&lrm;</span>
                    <span style={{ fontWeight: 400 }}>11 below.&nbsp;</span>
                </p>

                <h3 id="l-4">4. Data Retention</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We retain personal data for as long as reasonably necessary for us
                        to maintain and expand our relationship and provide you with our
                        Services and offerings; in order to comply with our legal and
                        contractual obligations; or to protect ourselves from any potential
                        disputes (i.e., as required by laws applicable to log-keeping,
                        records and bookkeeping, and to have proof and evidence concerning
                        our relationship, should any legal issues arise following your
                        discontinuance of use), all in accordance with our contractual terms
                        and data retention policy.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        To determine the appropriate retention period for personal data, we
                        consider the amount, nature, and sensitivity of the personal data,
                        the potential risk of harm from unauthorized use or disclosure of
                        your personal data, the purposes for which we process your personal
                        data, and the applicable legal requirements.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If you have any questions about our data retention practices, please
                        contact us by e-mail at{' '}
                    </span>
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>.&nbsp;</span>
                </p>

                <h3 id="l-5">5. Data Disclosure</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We disclose personal data in the following ways:
                    </span>
                </p>
                <p>
                    <strong>Service Providers:</strong>{' '}
                    <span style={{ fontWeight: 400 }}>
                        We may engage selected third-party companies and individuals to
                        perform services on our behalf or complementary to our own. Such
                        service providers include hosting and server co-location services,
                        communications and content delivery networks (CDNs), data security
                        services, billing and payment processing services, fraud detection
                        and prevention services, web and product analytics, e-mail
                        distribution and monitoring services, integrations and applications
                        creation services, session or activity recording services, remote
                        access services, content transcription and analysis services,
                        performance measurement, data optimization and marketing services,
                        social and advertising networks, content and data enrichment
                        providers, event production and hosting services, e-mail,
                        voicemails, support, enablement and customer relation management
                        systems, and our legal, financial and compliance advisors
                        (collectively, &ldquo;
                    </span>
                    <strong>Service Providers</strong>
                    <span style={{ fontWeight: 400 }}>
                        &ldquo;). Our Service Providers may have access to personal
                        information, depending on each of their specific roles and purposes
                        in facilitating and enhancing our Services, and may only use the
                        data as determined in our agreements with them.
                    </span>
                </p>
                <p>
                    <strong>Legal Compliance:</strong>{' '}
                    <span style={{ fontWeight: 400 }}>
                        We may disclose or allow government and law enforcement officials
                        access to your personal data, in response to a subpoena, search
                        warrant or court order (or similar requirement), or in compliance
                        with applicable laws and regulations. Such disclosure or access may
                        occur if we believe in good faith that: (a) we are legally compelled
                        to do so; (b) disclosure is appropriate in connection with efforts
                        to investigate, prevent, or take action regarding actual or
                        suspected illegal activity, fraud, or other wrongdoing; or (c) such
                        disclosure is required to protect our legitimate business interests,
                        including the security or integrity of our products and services.
                    </span>
                </p>
                <p>
                    <strong>Event Sponsors:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        If you attend an event or webinar organized by us, or download or
                        access an asset on our website related to such an event, webinar or
                        other activity involving third party sponsors or presenters,
                    </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        we may share your personal data with them. If required by applicable
                        law, you may consent to such sharing via the registration form or by
                        allowing your attendee badge to be scanned at a sponsor booth. In
                        these circumstances, your personal data will be subject to the
                        sponsors&rsquo; privacy statements. If you do not wish for your
                        personal data to be shared, you may choose to not opt-in via
                        event/webinar registration or elect to not have your badge scanned,
                        or you can opt-out in accordance with Section{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>9</span>
                    <span style={{ fontWeight: 400 }}> below.</span>
                </p>
                <p>
                    <strong>Protecting Rights and Safety:</strong>{' '}
                    <span style={{ fontWeight: 400 }}>
                        We may share your personal data with others if we believe in good
                        faith that this will help protect the rights, property or personal
                        safety of Common Ninja, any of our Users, Customers and Prospects or
                        any members of the general public.
                    </span>
                </p>
                <p>
                    <strong>
                        Common Ninja&nbsp;Subsidiaries and Affiliated Companies:
                    </strong>{' '}
                    <span style={{ fontWeight: 400 }}>
                        We may share personal data internally within Common Ninja&rsquo;s
                        group of subsidiaries and affiliates for the purposes described in
                        this Privacy Policy. In addition, should Common Ninja or any of its
                        subsidiaries or affiliates undergo any change in control, including
                        by means of merger, acquisition or purchase of substantially all of
                        its assets, your personal data may be shared with the parties
                        involved in such event. If we believe that such change in control
                        might materially affect your personal data then stored with us, we
                        will notify you of this event and the choices you may have via
                        e-mail or prominent notice on our Services.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        For the avoidance of doubt, Common Ninja may share your personal
                        data in additional manners, such as pursuant to your explicit
                        approval, if we are legally obligated to do so, or if we have
                        successfully rendered such data non-personal and anonymous. We may
                        transfer, share or otherwise use non-personal data at our sole
                        discretion and without the need for further approval.
                    </span>
                </p>

                <h3 id="l-6">6. Cookies and Data Collection Technologies</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We and our Service Providers use cookies and other technologies for
                        performance, tracking, analytics and personalization purposes. We
                        may share non-identifiable / aggregated extracts of such information
                        with our partners for our legitimate business purposes.&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Cookies are packets of information sent to your web browser and then
                        send back by the browser each time it accesses the server that sent
                        the cookie. Some cookies are removed when you close your browser
                        session. These are the &ldquo;Session Cookies&rdquo;. Some last for
                        longer periods and are called &ldquo;Persistent Cookies&rdquo;. We
                        use both types.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We use Persistent Cookies to remember your log-in details and make
                        it easier for you to log-in the next time you access the Platform.
                        We may use this type of cookies and Session Cookies for additional
                        purposes, to facilitate the use of the Services&rsquo; features and
                        tools. We may also use HTML5 local storage or Flash cookies for the
                        above-mentioned purposes. These technologies differ from browser
                        cookies in the amount and type of data they store, and how they
                        store it.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Whilst we do not change our practices in response to a &ldquo;Do Not
                        Track&rdquo; signal in the HTTP header from a browser or mobile
                        application, you can manage your cookies preferences, including
                        whether or not to accept them and how to remove them, through your
                        browser settings. Please bear in mind that disabling cookies may
                        complicate or even prevent you from using the Services.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We also use web analytics tools, including Google Analytics and
                        Mixpanel. These tools help us understand Users&rsquo; and
                        Prospects&rsquo; behavior on our Services, including by tracking
                        page content, and click/touch, movements, scrolls and keystroke
                        activities. Further information about the privacy practices of our
                        analytics service providers is available at:{' '}
                    </span>
                    <a href="http://www.google.com/policies/privacy/partners/">
                        <span style={{ fontWeight: 400 }}>
                            www.google.com/policies/privacy/partners/
                        </span>
                    </a>
                    <span style={{ fontWeight: 400 }}> and </span>
                    <a href="https://mixpanel.com/terms/">
                        <span style={{ fontWeight: 400 }}>https://mixpanel.com/terms/</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        . Further information about your option to opt-out of these
                        analytics services is available at:{' '}
                    </span>
                    <a href="https://tools.google.com/dlpage/gaoptout">
                        <span style={{ fontWeight: 400 }}>
                            https://tools.google.com/dlpage/gaoptout
                        </span>
                    </a>
                    <span style={{ fontWeight: 400 }}> and </span>
                    <a href="https://mixpanel.com/optout">
                        <span style={{ fontWeight: 400 }}>https://mixpanel.com/optout</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        . Please note that if you get a new computer, install a new browser,
                        erase or otherwise alter your browser&rsquo;s cookie file (including
                        upgrading certain browsers), you may also clear the opt-out cookies
                        installed once you opt-out, so an additional opt-out will be
                        necessary to prevent additional tracking.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        For more information on our cookie and data collection technologies
                        practices, you may also use the &ldquo;Cookie Settings&rdquo;
                        feature available in our Services depending on your location and
                        activity on our Services, as applicable.
                    </span>
                </p>

                <h3 id="l-7">7. Communications</h3>
                <p>
                    <strong>Service Communications: </strong>
                    <span style={{ fontWeight: 400 }}>
                        We may contact you with important information regarding our
                        Services. For example, we may send you notifications (through any of
                        the means available to us) of changes or updates to our Services,
                        billing issues, log-in attempts or password reset notices, etc. If
                        you are registered as a User on our Platform, you can typically
                        control your communications and notifications settings from your
                        profile settings, or otherwise in accordance with the instructions
                        included in the communications sent to you. Please note that you
                        will not be able to opt out of receiving certain service
                        communications which are integral to your use (like password resets
                        or billing notices).
                    </span>
                </p>
                <p>
                    <strong>Promotional Communications:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        We may also notify you about new features, additional offerings,
                        events, special opportunities or any other information we think you
                        will find valuable, as our User, Customer or Prospect. We may
                        provide such notices through any of the contact means available to
                        us (e.g., phone, mobile or e-mail), through the Services, or through
                        our marketing campaigns on any other sites or platforms.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If you do not wish to receive such promotional communications, you
                        may notify us at any time by sending an e-mail to:{' '}
                    </span>
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        , changing your communications preferences in your profile settings
                        whilst being logged to the Platform, or by following the
                        &ldquo;unsubscribe&rdquo;, &ldquo;stop&rdquo;, &ldquo;opt-out&rdquo;
                        or &ldquo;change e-mail preferences&rdquo; instructions contained in
                        the promotional communications you receive.
                    </span>
                </p>

                <h3 id="l-8">8. Data Security</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We implement systems, applications and procedures designed to secure
                        your personal data, to minimize the risks of theft, damage, loss of
                        information, or unauthorized access or use of information. However,
                        we cannot guarantee that our Services will be immune from any
                        wrongdoings, malfunctions, unlawful interceptions or access, or
                        other kings of abuse and misuse.
                    </span>
                </p>

                <h3 id="l-9">9. Data Subject Rights</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Individuals have rights concerning their personal data. Please
                        contact us by e-mail at:{' '}
                    </span>
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        if you wish to exercise your privacy rights under any applicable
                        law, including the EU or UK General Data Protection Regulation
                        (GDPR) or the California Consumer Privacy Act (CCPA), such as
                        &ndash; to the extent applicable &ndash; the right to know/request
                        access to (specific pieces of personal data collected; categories of
                        personal data collected; categories of sources from whom the
                        personal data was collected; purpose of collecting personal data;
                        categories of third parties with whom we have shared personal data),
                        to request rectification or erasure of your personal data held with
                        Common Ninja, or to restrict or object to such personal data&rsquo;s
                        processing (including the right to direct us not to sell your
                        personal data to third parties now or in the future), or to port
                        such personal data, or the right to equal services and prices (e.g.
                        freedom from discrimination) (each to the extent available to you
                        under the laws which apply to you). If you are a GDPR-protected
                        individual, you also have the right to lodge a complaint with the
                        relevant supervisory authority in the EU or the UK, as applicable.
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Please note that when you ask us to exercise any of your rights
                        under this policy or applicable law, we may need to ask you to
                        provide us certain credentials to make sure that you are who you
                        claim you are, to avoid disclosure to you of personal data related
                        to others and to ask you to provide further information to better
                        understand the nature and scope of data that you request to access.
                        Such additional data will be then retained by us for legal purposes
                        (e.g., as proof of the identity of the person submitting the
                        request).
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        We may redact from the data which we will make available to you, any
                        personal data related to others.
                    </span>
                </p>

                <h3 id="l-10">10. Data Controller/Processor</h3>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Certain data protection laws and regulations, such as the EU GDPR,
                        UK GDPR or the CCPA, typically distinguish between two main roles
                        for parties processing personal data: the &ldquo;Data
                        Controller&rdquo; (or under the CCPA, &ldquo;business&rdquo;), who
                        determines the purposes and means of processing; and the &ldquo;Data
                        processor&rdquo; (or under the CCPA, &ldquo;service
                        provider&rdquo;), who processes the data on behalf of the Data
                        Controller (or business, if the CCPA applies). Below we explain how
                        these roles apply to our Services, to the extent that such laws and
                        regulations apply.
                    </span>
                </p>
                <p>
                    <strong>
                        Common Ninja is the &ldquo;Data Controller&rdquo; of its User,
                        Prospect and Customer Data
                    </strong>
                    <span style={{ fontWeight: 400 }}>
                        . With respect to these categories of personal data, we assume the
                        responsibilities of Data Controller (solely to the extent applicable
                        under law), as set forth in this Privacy Policy. When we process
                        personal data as a Data Controller, our Service Providers processing
                        such data on our behalf will assume the role of &ldquo;Data
                        processor&rdquo;, in accordance with the instructions given to them
                        by us and in accordance with the data processing agreement we have
                        with them.
                    </span>
                </p>
                <p>
                    <strong>
                        Common Ninja is the &ldquo;Data Processor&rdquo; of End-User
                        Information
                    </strong>
                    <span style={{ fontWeight: 400 }}>
                        . We receive such End-User Information through our Common Ninja API
                        or through other features, applications or widgets of our Platform
                        used by our Users to share with us End-User Data. In such cases, we
                        will process such data solely on behalf of the respective User or
                        Customer (as appropriate), under their reasonable instructions, and
                        in accordance with our{' '}
                    </span>
                    <Link href="/terms">
                        <span style={{ fontWeight: 400 }}>Terms &amp; Conditions</span>
                    </Link>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        and our <Link href="/privacy/dpa">Data Processing Addendum</Link>. Accordingly, our Users and
                        Customers will be responsible for meeting any legal requirements
                        applicable to Data Controllers (such as establishing a legal basis
                        for processing and responding to Data Subject Rights requests
                        concerning the data they control).
                    </span>
                </p>

                <h3 id="l-11">11. Additional Notices</h3>
                <p>
                    <strong>Updates and Amendments:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        We may update and amend this Privacy Policy from time to time by
                        posting an amended version on our Services. The amended version will
                        be effective as of the date it is published. We will provide prior
                        notice if we believe any substantial changes are involved via any of
                        the communication means available to us or via the Services. After
                        such notice period, all amendments shall be deemed accepted by you.
                    </span>
                </p>
                <p>
                    <strong>External Links:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        While our Services may contain links to other websites or services,
                        we are not responsible for their privacy practices. We encourage you
                        to pay attention when you leave our Services for the website or
                        application of such third parties and to read the privacy policies
                        of each and every website or service you visit. This Privacy Policy
                        applies only to our Services.
                    </span>
                </p>
                <p>
                    <strong>California Requirements: </strong>
                    <span style={{ fontWeight: 400 }}>
                        This Privacy Policy describes the categories of personal information
                        we may collect and the sources of such information (in{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Section </span>
                    <em>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                    </em>
                    <span style={{ fontWeight: 400 }}>1</span>
                    <span style={{ fontWeight: 400 }}> above), and our retention (</span>
                    <span style={{ fontWeight: 400 }}>Section </span>
                    <em>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                    </em>
                    <span style={{ fontWeight: 400 }}>4</span>
                    <span style={{ fontWeight: 400 }}>) and deletion (</span>
                    <span style={{ fontWeight: 400 }}>Section </span>
                    <em>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                    </em>
                    <span style={{ fontWeight: 400 }}>9</span>
                    <span style={{ fontWeight: 400 }}>
                        ) practices. We also included information about how we may process
                        your information (in{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Sections </span>
                    <em>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                    </em>
                    <span style={{ fontWeight: 400 }}>2 through </span>
                    <em>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                    </em>
                    <span style={{ fontWeight: 400 }}>7</span>
                    <span style={{ fontWeight: 400 }}>
                        ), which includes for &ldquo;business purposes&rdquo; under the
                        California Consumer Privacy Act (CCPA). We do not sell your personal
                        information for the intents and purposes of CCPA. We may disclose
                        personal data to third parties or allow them to collect personal
                        data from our Services as described in{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Section </span>
                    <span style={{ fontWeight: 400 }}>&lrm;</span>
                    <span style={{ fontWeight: 400 }}>5</span>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        above, if those third parties are authorized Service Providers or
                        business partners who have agreed to our contractual limitations as
                        to their retention, use, and disclosure of such personal data, or if
                        you integrate the services of third parties with our Services, or
                        direct us to disclose your personal data to third parties, or as
                        otherwise described in{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Section 5</span>
                    <span style={{ fontWeight: 400 }}> above.</span>
                </p>
                <p>
                    <strong>Children:</strong>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        Our Services are not designed to attract children under the age of
                        16. We do not knowingly collect personal data from children and do
                        not wish to do so. If we learn that a person under the age of 16 is
                        using the Services, we will attempt to prohibit and block such use
                        and will make our best efforts to promptly delete any personal data
                        stored with us with regard to such child. If you believe that we
                        might have any such data, please contact us by e-mail at
                    </span>{' '}
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>.&nbsp;</span>
                </p>
                <p>
                    <strong>Contacting Us:</strong>{' '}
                    <span style={{ fontWeight: 400 }}>
                        if you have any comments or questions regarding our Privacy Policy,
                        if you have any concerns regarding your personal data held with us,
                        or if you wish to make a complaint about how your personal data is
                        being processed by Common Ninja, please contact us by email by
                        sending us a message to{' '}
                    </span>
                    <a href="mailto:privacy@commoninja.com">
                        <span style={{ fontWeight: 400 }}>privacy@commoninja.com</span>
                    </a>
                    <span style={{ fontWeight: 400 }}>.&nbsp;&nbsp;</span>
                </p>
            </LongCopy>
        </Layout>
    );
}
